/* js/components/UserMarkerLibre.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

import { onMount, onDestroy } from 'svelte';
import maplibregl, { Map, Marker, MarkerOptions, Popup } from "maplibre-gl";

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager';

import { getContext } from 'svelte';
import { key } from '../maplibre.js';
import { genevaCoords } from '../geoUtils.js';

function create_fragment(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "svelte-enwn0t");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			/*div_binding*/ ctx[1](div);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			/*div_binding*/ ctx[1](null);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const { getMap } = getContext(key);
	const map = getMap();
	let marker;
	let markerElement;

	function onGeoLocationStarted() {
		if (geoLocationManager.currentCoords) {
			marker.setLngLat(geoLocationManager.currentCoords.coords);
			showMarker();
		}
	}

	function onGeoLocationFirstValue(event) {
		// console.log("UserMarker: on geoLocation update --------------------", event.value);
		if (marker) {
			marker.setLngLat(event.value.coords);
			showMarker();
		} else {
			hideMarker();
		}
	}

	function onGeoLocationUpdate(event) {
		// console.log("UserMarker: on geoLocation update --------------------", event.value);
		if (marker && event.value.coords) {
			marker.setLngLat(event.value.coords);
			showMarker();
		} else {
			hideMarker();
		}
	}

	function onGeoLocationError(event) {
		// console.log("on error ---------------------------");
		if (geoLocationManager.serviceState == GeoLocationServiceState.PERMISSION_DENIED || geoLocationManager.serviceState == GeoLocationServiceState.UNSUPPORTED_DEVICE) {
			hideMarker();
		}
	}

	function onGeoLocationStopped() {
		// console.log("on stopppedd ---------------------------");
		hideMarker();
	}

	function showMarker() {
		if (markerElement) {
			// console.log("show marker");
			$$invalidate(0, markerElement.style.visibility = "visible", markerElement);
		}
	}

	function hideMarker() {
		if (markerElement) {
			// console.log("hide marker");
			$$invalidate(0, markerElement.style.visibility = "hidden", markerElement);
		}
	}

	onMount(() => {
		const options = { element: markerElement, anchor: 'center' };
		const startLocation = genevaCoords;
		marker = new maplibregl.Marker(options).setLngLat(startLocation).addTo(map);

		// TODO: remove this
		window.marker = markerElement;

		geoLocationManager.addEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationFirstValue);
		geoLocationManager.addEventListener(GeolocationEventType.coords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.locationError, onGeoLocationError);
		geoLocationManager.addEventListener(GeolocationEventType.stopped, onGeoLocationStopped);

		if (geoLocationManager.isStarted && geoLocationManager.currentCoords) {
			marker.setLngLat(geoLocationManager.currentCoords.coords);
			showMarker();
		} else {
			hideMarker();
		}
	});

	onDestroy(() => {
		console.log("removing user marker-----------------");
		geoLocationManager.removeEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationFirstValue);
		geoLocationManager.removeEventListener(GeolocationEventType.coords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.locationError, onGeoLocationError);
		geoLocationManager.removeEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
	});

	function div_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			markerElement = $$value;
			$$invalidate(0, markerElement);
		});
	}

	return [markerElement, div_binding];
}

class UserMarkerLibre extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default UserMarkerLibre;